<template>
  <v-row>
    <v-col cols="12" sm="9">
      <v-card class="pa-5 mb-3">
        <v-row>
          <v-col cols="12" sm="4" class="d-flex align-center justify-center">
            <p class="mr-2 mb-0 d-inline-block">{{ $t("checks.totalTime") }}</p>
            <v-img class="d-inline-block" max-height="25" max-width="25" :src="checkImage(totalTimeCheck)"></v-img>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex align-center justify-center">
            <p class="mr-2 mb-0 d-inline-block">{{ $t("checks.summary") }}</p>
            <v-img class="d-inline-block" max-height="25" max-width="25" :src="checkImage(dailySummaryCheck)"></v-img>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex align-center justify-center">
            <p class="mr-2 mb-0 d-inline-block">{{ $t("checks.progress") }}</p>
            <v-img class="d-inline-block" max-height="25" max-width="25" :src="checkImage(progressCheck)"></v-img>
          </v-col>
          <v-col cols="12" sm="6" class="d-flex align-center justify-center">
            <p class="mr-2 mb-0 d-inline-block">{{ $t("checks.activities") }}</p>
            <v-img class="d-inline-block" max-height="25" max-width="25" :src="checkImage(activitiesCheck)"></v-img>
          </v-col>
          <v-col cols="12" sm="6" class="d-flex align-center justify-center">
            <p class="mr-2 mb-0 d-inline-block">{{ $t("checks.dailyActivitiesCheck") }}</p>
            <v-img class="d-inline-block" max-height="25" max-width="25" :src="checkImage(dailyActivityCheck)"></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="12" sm="2" id="btnsDPR">
      <!--<v-btn id="btn1" class="text-none" color="primary">{{ $t("checks.print") }}</v-btn> -->
      <!-- <v-btn id="btn2" class="text-none" color="primary" :disabled="enabled"> {{ $t('checks.upload') }}</v-btn> -->
      <!-- <v-btn id="btn3" class="text-none" color="primary" disabled> {{ $t('checks.create') }}</v-btn> -->
    </v-col>
    <v-col cols="12" sm="1">
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn id="sbtn1" color="primary" style="margin-bottom: 5px" v-bind="attrs" v-on="on" @click="viewPdfFor(true)">
            <v-icon color="white"> mdi-sync </v-icon>
          </v-btn>
        </template>
        <span>Create a new DPR version</span>
      </v-tooltip>-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn id="sbtn2" color="white" @click="viewPdfFor()" v-bind="attrs" v-on="on">
            <v-icon color="primary">mdi-file-pdf</v-icon>
          </v-btn>
        </template>
        <span>View last DPR version</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      totalTimeCheck: true,
      dailySummaryCheck: true,
      progressCheck: true,
      activitiesCheck: true,
      currentMainDprId: null,
      currentPVId: null,
    };
  },
  computed: {
    ...mapGetters(["mv_vesselActivity/getVesselActivities", "mv_dprHeader/getDprHeader", "mv_vesselMacroActivity/getMacroActivities"]),
    activities() {
      return this["mv_vesselActivity/getVesselActivities"];
    },

    header() {
      console.log(this["mv_dprHeader/getDprHeader"]);
      return this["mv_dprHeader/getDprHeader"];
    },

    macroActivity() {
      console.log(this["mv_vesselMacroActivity/getMacroActivities"]);
      return this["mv_vesselMacroActivity/getMacroActivities"];
    },

    dailyActivityCheck() {
      let totalhoursmacroact = 0;

      this.macroActivity.forEach((item) => {
        totalhoursmacroact += item.totalForced ? item.totalForced : item.total;
      });
      console.log(totalhoursmacroact, this.header?.totalHours);
      if (totalhoursmacroact != this.header?.totalHours) {
        return false;
      } else return true;
    },
  },

  methods: {
    ...mapActions(["mv_vesselActivity/fetchVesselActivities", "mv_dprHeader/fetchDprHeader", "mv_vesselMacroActivity/fetchMacroActivitiesByDprId"]),

    checkImage(check) {
      return check ? "img/check.png" : "img/red-x.png";
    },

    calculateChecks() {
      this.totalTimeCheck = false;
      this.dailySummaryCheck = false;
      this.progressCheck = false;
      this.activitiesCheck = false;

      if (this.activities.length == 0) {
        return;
      }

      this.dailySummaryCheck = true;
      this.progressCheck = true;
      this.activitiesCheck = true;

      let deltaTSum = 0;

      for (var i = 0; i < this.activities.length; i++) {
        let activity = this.activities[i];
        deltaTSum += parseFloat(activity.deltaT);

        if (this.dailySummaryCheck && !activity.activityCategory) {
          this.dailySummaryCheck = false;
        }

        if (this.progressCheck && !activity.activityId) {
          this.progressCheck = false;
        }

        if (this.activitiesCheck && !activity.macroActivityId) {
          this.activitiesCheck = false;
        }
      }

      let dprHeader = this.header;
      if (typeof dprHeader == "undefined" || null == dprHeader) {
        this.totalTimeCheck = false;
        return;
      }

      let isCummulative = dprHeader.cumulativeDpr;
      this.$log.debug("computing total time check for ", isCummulative ? "cumulative" : "daily", "dpr", dprHeader.dprNumber);

      let startDateTime = moment.utc(this.formatDate(dprHeader.dprDate, dprHeader.timeStart));
      let endDateTime = moment.utc(this.formatDate(isCummulative ? dprHeader.endDate : dprHeader.dprDate, dprHeader.timeEnd));
      this.$log.debug("duration(DPR) = duration(", startDateTime.toLocaleString(), ",", endDateTime.toLocaleString());
      let dprDuration = moment.duration(endDateTime.diff(startDateTime));

      this.$log.debug("Sum(deltaT): ", deltaTSum, "= duration(DPR):", dprDuration.asMinutes());

      let isbefore = false;
      let totaltime = false;

      this.activities.forEach((activity) => {
        let headerend = this.formatDate(this.header.endDate, this.header.timeEnd);
        let activitydateend = activity.date;

        if (moment(headerend).isBefore(moment(activitydateend))) {
          isbefore = false;
        }
        if (headerend == activitydateend) {
          totaltime = true;
        }
      });

      this.totalTimeCheck = isbefore ? isbefore : totaltime;

      /* this.totalTimeCheck = deltaTSum == dprDuration.asMinutes(); */

      // if (this.activities.length == 0) {
      //   this.totalTimeCheck = false
      //   this.dailySummaryCheck = false
      //   this.progressCheck = false
      //   this.activitiesCheck = false
      // } else {
      //   this.totalTimeCheck = true
      //   this.dailySummaryCheck = true
      //   this.progressCheck = true
      //   this.activitiesCheck = true
      //   var calculatedTime = moment().startOf('day')
      //   for (var i = 0; i < this.activities.length; i++) {
      //     var [hours, minutes] = this.activities[i].timeCompiling.split(':')
      //     calculatedTime = moment(calculatedTime).add(parseInt(hours), 'hours').add(parseInt(minutes), 'minutes')
      //   }
      //   for (var j = 0; j < this.activities.length; j++) {
      //     if (!this.activities[j].activityCategory) {
      //       this.dailySummaryCheck = false
      //       break
      //     }
      //   }
      //   for (var k = 0; k < this.activities.length; k++) {
      //     if (!this.activities[k].activityId) {
      //       this.progressCheck = false
      //       break
      //     }
      //   }
      //   for (var l = 0; l < this.activities.length; l++) {
      //     if (!this.activities[l].macroActivityId) {
      //       this.activitiesCheck = false
      //       break
      //     }
      //   }
      //   var difference = moment(calculatedTime).diff(moment().startOf('day'))
      //   var duration = moment.duration(difference).asDays()
      //   this.totalTimeCheck = duration > 1 ? false : true
      // }
    },

    viewPdfFor() {
      let dprPdfReportUrl = "dpr-header/" + this.currentMainDprId + "/pdf-report";
      window.open(Vue.$url(dprPdfReportUrl), "_blank");
    },

    formatDate(dateTime, time) {
      const [date] = dateTime.split("T");
      return [date, time].join("T");
    },
  },
  created() {
    this.currentMainDprId = this.$route.params.dprMainId;
    this.currentPVId = this.$route.params.pvId;
    this["mv_dprHeader/fetchDprHeader"](this.currentMainDprId).then(async () => {
      await this["mv_vesselMacroActivity/fetchMacroActivitiesByDprId"](this.header?.dprMainId);
      this.calculateChecks;
    });
    this["mv_vesselActivity/fetchVesselActivities"]({
      mainId: this.currentMainDprId,
    }).then(async () => {
      await this["mv_vesselMacroActivity/fetchMacroActivitiesByDprId"](this.header?.dprMainId);
      this.calculateChecks;
    });
  },

  // mounted() {
  //   this['mv_dprHeader/fetchDprHeader'](this.currentMainDprId).then(this.calculateChecks)
  //   this['mv_vesselActivity/fetchVesselActivities'](this.currentMainDprId).then(this.calculateChecks)
  // }
};
</script>
<style>
#btn1,
#btn2,
#btn3 {
  background-color: #000066;
  width: 160px;
  margin-bottom: 5px;
}
</style>
